<template>
  <div class="service-item">
    <div class="item" @click="$emit('showHotLine')">
      <div><img src="../assets/images/xuanzhong.svg"> 个人起名</div>
      <div><img src="../assets/images/xuanzhong.svg"> 商铺起名</div>
      <div><img src="../assets/images/xuanzhong.svg"> 公司起名</div>
    </div>
    <div class="reason" @click="$emit('showHotLine')">起名就找叶老师！</div>
    <div class="description">
      <img src="images/right-bg.jpg">
      <p class="who-am-i"><span>叶华仲</span>老师，诞于传统易学世家，通晓周易哲学之理，熟谙奇门遁甲之道。善于为个人、公司起名，婚姻福相推查，环境勘察调理，业有数十载。</p>
      <p>河北奇门企业管理服务有限公司在企业命名、企业战略咨询、企业环境布局、大型楼盘勘测、易学培训等多领域积累了丰富的专业咨询经验，取得了令业界瞩目的业绩。</p>
    </div>
    <h2 class="service-title">主要服务项目</h2>
    <ul class="service-ul">
      <li class="service-li">企业、个人、商铺、产品等起名、改名</li>
      <li class="service-li">厂矿选址与环境布局咨询</li>
      <li class="service-li">机关、学校、住宅、园林建筑格局规划</li>
      <li class="service-li">周易人才培养、企业策划师培训</li>
      <li class="service-li mark">烈军属、老弱病残可视情况减免费用</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'service-item',
  data () {
    return {
      showPop: false
    }
  }
}
</script>

<style scoped lang="scss">
  .service-item{
    margin: 0 -15px;
  }
  .item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 2rem;
    padding: 5px;
    div{
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 3;
      flex-grow: 1;
      text-align: center;
      margin: 5px;
      background: $yellow;
      text-shadow: rgba(255,255,255,.45) 0 1px 0;
      img{
        margin-right: 10px;
      }
    }
  }
  .reason{
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    margin: 0 10px;
    font-weight: 100;
    font-size: 2.1rem;
    color: #fff;
    overflow: hidden;
    background: rgba(255,108,82,1);
    background: -moz-linear-gradient(top, rgba(255,108,82,1) 0%, rgba(239,29,22,1) 17%, rgba(239,29,22,1) 83%, rgba(181,44,20,1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,108,82,1)), color-stop(17%, rgba(239,29,22,1)), color-stop(83%, rgba(239,29,22,1)), color-stop(100%, rgba(181,44,20,1)));
    background: -webkit-linear-gradient(top, rgba(255,108,82,1) 0%, rgba(239,29,22,1) 17%, rgba(239,29,22,1) 83%, rgba(181,44,20,1) 100%);
    background: -o-linear-gradient(top, rgba(255,108,82,1) 0%, rgba(239,29,22,1) 17%, rgba(239,29,22,1) 83%, rgba(181,44,20,1) 100%);
    background: -ms-linear-gradient(top, rgba(255,108,82,1) 0%, rgba(239,29,22,1) 17%, rgba(239,29,22,1) 83%, rgba(181,44,20,1) 100%);
    background: linear-gradient(to bottom, rgba(255,108,82,1) 0%, rgba(239,29,22,1) 17%, rgba(239,29,22,1) 83%, rgba(181,44,20,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff6c52', endColorstr='#b52c14', GradientType=0 );
    &:before,
    &:after{
      content: " ";
      display: block;
      width: 20px;
      height: 100%;
      border-radius: 10px;
      background-color: #de1c13;
    }
    &:before{
      margin-left: -10px;
    }
    &:after{
      margin-right: -10px;
    }
  }
  .description{
    margin: 0 10px;
    padding: 20px 30px;
    background: #f5eed7;
    font-size: 1.6rem;
    line-height: 26px;
    img{
      float: right;
      margin: 10px -10px 10px 25px;
      height: 150px;
      mix-blend-mode: darken;
    }
    p.who-am-i span{
      font-size: 2em;
      line-height: 26px;
    }
  }
  .mobile {
    .item{
      font-size: 1.6rem;
    }
    .description{
      padding: 10px 15px;
    }
  }
  .service-ul {
    margin: 10px;
    background-color: #f5eed7;
    padding: 5px 15px;
    .service-li {
      background: url("../assets/images/xuanzhong.svg") no-repeat 0 center;
      list-style: none;
      padding: 0 10px 0 24px;
      font-size: 1.5rem;
      line-height: 40px;
      margin: 0;
      &:not(:first-child){
        border-top: thin dotted #B7B7B7;
      }
      &.mark{
        background-image: url("../assets/images/free.svg");
        background-size: 18px;
      }
    }
  }
  .service-title{
    margin: 10px;
    margin-top: 15px;
    text-align: center;
    line-height: 1.5;
    font-weight: normal;
    color: $red;
  }
</style>
